module.exports = __webpack_public_path__ + "img/myplan-poster.69f6b4c2.jpg";